import { RemoteWallboxUpdateState, RemoteWallboxFirmwareUpdateVersion } from '@kw-shared/api-data-access';

export interface RemoteWallboxFirmwareUpdateInfoDTO {
  updateId: string;
  currentVersion: string;
  nextAvailableVersion?: RemoteWallboxFirmwareUpdateVersion;
  description: string;
  updateIndication: RemoteWallboxUpdateState;
}
